import { Chip } from "@mui/material";

interface BadgeSituacaoProps {
  situacao?: string | null;
}

// Situações gravadas pela tela: "Validação", "Homologação"/"Em Homologação", "Disponível Mercado"
const BadgeSituacao = ({ situacao }: BadgeSituacaoProps) => {
  if (!situacao) return <>-</>;

  const texto = situacao.toLowerCase();
  let cores = { bgcolor: "#ECEFF1", color: "#455A64" };
  if (texto.includes("mercado")) {
    cores = { bgcolor: "#E3F2FD", color: "#1565C0" };
  } else if (texto.includes("homolog")) {
    cores = { bgcolor: "#FFF3E0", color: "#E65100" };
  }

  return <Chip label={situacao} size="small" sx={{ ...cores, fontWeight: 600 }} />;
};

export default BadgeSituacao;
